import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { includes } from 'lodash-es';
import { FormSettingsEnum } from '@dev/ee-api/ee-api-models';
import { SimpleToggle, Typography } from '@dev/ee-components';
import { getFormCreatorStore } from '@/store/formCreator/actions';
import { ToggleWrapper, EmailsListWrapper } from './styledComponents';

export const Step4Content = (): JSX.Element => {
    const { t } = useTranslation();
    const { formObject } = useSelector(getFormCreatorStore);
    const value = formObject?.EmailsToNotifyOnAction ?? '';
    const notify = includes(formObject?.FormSettings, FormSettingsEnum.NotifyEmails);

    return (
        <>
            <ToggleWrapper>
                <SimpleToggle
                    id="forms-notifications-toggle"
                    value="formsNotifications"
                    label={t('forms_notifications_togglelabel')}
                    checked={notify}
                    disabled
                />
            </ToggleWrapper>
            {notify && (
                <EmailsListWrapper>
                    <Typography variant='body1'>{value?.split(";").map(item => item.trim()).join("; ")}</Typography>
                </EmailsListWrapper>
            )}
        </>
    );
};
